import { GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE } from 'react-admin';
import { HttpClientResponse } from '@/services/api/types';
import { ContentRangeError, getTotal } from './utils';
import { DataProviderPayload, FetchType, HandleResponse } from './types';

export const handleResponse = (
  res: HttpClientResponse,
  type: FetchType,
  payload: DataProviderPayload
): HandleResponse => {
  const { headers, json } = res;

  switch (type) {
    case GET_MANY:
      if (!Array.isArray(json)) {
        throw new Error('GET_MANY response must be an array');
      }
      return { data: json };

    case GET_LIST:
    case GET_MANY_REFERENCE: {
      if (!headers.has('content-range')) {
        throw ContentRangeError;
      }

      if (!Array.isArray(json)) {
        throw new Error('GET_LIST response must be an array');
      }

      const countDeferred = headers.get('x-count-deferred') === '1';
      return {
        data: json,
        total: getTotal(headers),
        ...(countDeferred ? { meta: { countDeferred: true } } : {}),
      };
    }

    case GET_ONE:
    case CREATE:
    case UPDATE:
    case 'PATCH':
      return {
        data: {
          id: payload?.id, // Backend returns {} in most cases, React Admin expects an object with an id
          ...(payload?.data?.pw && { pw: payload?.data?.pw }),
          ...json,
        },
      };

    default:
      throw new Error(`Unsupported fetch type: ${type}`);
  }
};
